<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
    <el-form-item label="树种名称" prop="treeName">
      <el-input v-model="queryParams.treeName" placeholder="请输入树种名称" clearable style="width: 240px" @keyup.enter.native="handleQuery"/>
    </el-form-item>
    <el-form-item label="合种人数" prop="cooperateNum">
      <el-select v-model="queryParams.cooperateNum" placeholder="最大合种人数" clearable>
        <el-option :key="1" label="不支持" :value="1"/>
        <el-option :key="2" label="2人" :value="2"/>
        <el-option :key="60" label="60人" :value="60"/>
      </el-select>
    </el-form-item>
    <el-form-item label="合种天数" prop="cooperateDay">
      <el-input-number v-model="queryParams.cooperateDay" style="width: 220px" :min="1" :max="6" @change="handleQuery"/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
      <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
    </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['forest:tree:add']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['forest:tree:export']" type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="treeList" border>
      <el-table-column type="index" :index="handleIndex" label="序号" align="center" width="60"/>
      <el-table-column label="树种名称" align="center" prop="treeName" min-width="100" />
      <el-table-column label="树种图片" align="center" prop="treeImg" min-width="150">
        <template slot-scope="scope">
          <image-preview :src="scope.row.treeImg" :width="90" :height="90" />
        </template>
      </el-table-column>
      <el-table-column label="所需总能量（g）" align="center" prop="totalPower"  min-width="160"/>
      <el-table-column label="最大合种人数" align="center" prop="cooperateNum"  min-width="160">
        <template slot-scope="scope">
          {{ scope.row.cooperateNum == null || scope.row.cooperateNum === 0 || scope.row.cooperateNum === 1 ? '-' : scope.row.cooperateNum }}
        </template>
      </el-table-column>
      <el-table-column label="合种平均能量（g）" align="center" prop="avgPower" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.avgPower == null || scope.row.avgPower === 0 ? '-' : scope.row.avgPower }}
        </template>
      </el-table-column>
      <el-table-column label="合种天数" align="center" prop="cooperateDay" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.cooperateDay == null || scope.row.cooperateDay === 0 ? '-' : scope.row.cooperateDay }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120">
        <template slot-scope="scope">
          <el-button v-hasPermi="['forest:tree:edit']" size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button v-hasPermi="['forest:tree:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
      :page-sizes="[5, 10, 20, 50]"
    />

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false" >
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="树种名称" prop="treeName">
              <el-input v-model="form.treeName" placeholder="请输入树种名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="树种图片" prop="treeImg">
              <image-upload v-model="form.treeImg" :limit="1" action="/admin/forest/tree/images">
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="所需总能量（g）" prop="totalPower">
              <el-input v-model="form.totalPower" placeholder="请输入所需总能量（g）" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="最大合种人数" prop="cooperateNum">
              <el-select v-model="form.cooperateNum" placeholder="请选择最大合种人数">
                <el-option :key="1" label="不支持" :value="1"/>
                <el-option :key="2" label="2人" :value="2"/>
                <el-option :key="60" label="60人" :value="60"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listForestTree, getForestTree, delForestTree, addForestTree, updateForestTree } from '@/api/forest/tree';

export default {
  name: "ForestTree",
  data() {
    var validatePower = (rule, value, callback) => {
      const pattern = /^\d{1,6}$/
      if (!value) {
        callback(new Error('请输入总能量'))
      } else if (!pattern.test(value)) {
        callback(new Error('总能量格式不正确!'))
      } else {
        callback()
      }
    }
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 树种表格数据
      treeList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        current: 1,
        size: 5,
        treeName: undefined,
        cooperateNum: undefined,
        cooperateDay: undefined
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        treeName: [
          { required: true, message: "树种名称不能为空", trigger: "blur" }
        ],
        treeImg: [
          { required: true, message: "树种图片不能为空", trigger: "blur" }
        ],
        totalPower: [
          { required: true, message: "所需总能量（g）不能为空", trigger: "blur" },
          { validator: validatePower, trigger: 'blur' }
        ],
        cooperateNum: [
            { required: true, message: "最大合种人数不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleIndex(index){
      return (this.queryParams.current - 1) * this.queryParams.size + (index + 1)
    },
    /** 查询树种类型列表 */
    getList() {
      this.loading = true;
      listForestTree(this.queryParams).then(res => {
          this.treeList = res.rows;
          this.total = res.total;
          this.loading = false;
        }
      );
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        treeId: undefined,
        treeName: undefined,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加蚂蚁森林地图树种";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const treeId = row.treeId
      getForestTree(treeId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改蚂蚁森林地图树种";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.treeId != undefined) {
            updateForestTree(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addForestTree(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const treeId = row.treeId;
      this.$modal.confirm('是否确认删除树种名称为"' + row.treeName + '"的数据项？').then(function() {
        return delForestTree(treeId);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('/admin/forest/tree/export', {
        ...this.queryParams
      }, `蚂蚁森林树种_${new Date().getTime()}.xlsx`)
    },
  }
};
</script>
